import type { MessagePersonResponse, MessageResponse } from '@/entities/conversations';
import { getShortName } from '@/shared/lib';

/** Содержимое облака: оформленное (HTML) либо простой текст */
export type MessageContentSource = { kind: 'html'; html: string } | { kind: 'text'; text: string };

/** Служебное упоминание в заметке вместе с пробелом за ним */
const NOTE_MENTION = /@\[note_mention:::[^\]]*\] ?/g;

/** Несколько переносов строки подряд */
const REPEATED_LINE_BREAKS = /\n{2,}/g;

/** Непустое оформленное содержимое показывается вместо текста */
export const getMessageContentSource = (message: MessageResponse): MessageContentSource => {
  if (message.contentHtml?.trim()) return { kind: 'html', html: message.contentHtml };
  return { kind: 'text', text: message.text ?? '' };
};

/** Содержимое заметки: без служебных упоминаний и с одним переносом вместо нескольких подряд */
export const cleanNoteContent = (content: string): string =>
  content.replace(NOTE_MENTION, '').replace(REPEATED_LINE_BREAKS, '\n');

/** Имя участника над облаком — короткое имя ({@link getShortName}); известных частей нет — имени нет */
export const getMessagePersonName = (person?: MessagePersonResponse | null): string | null =>
  getShortName(person?.firstName, person?.lastName, person?.middleName) || null;

/** Содержимое заметки — то же, что у сообщения, но очищенное ({@link cleanNoteContent}) */
export const getNoteContentSource = (message: MessageResponse): MessageContentSource => {
  const source = getMessageContentSource(message);
  return source.kind === 'html'
    ? { kind: 'html', html: cleanNoteContent(source.html) }
    : { kind: 'text', text: cleanNoteContent(source.text) };
};
